import styled, {css} from 'styled-components';

interface ItemProps {
  readonly cursor?: string;
  readonly decoration?: string;
  readonly fontWeight?: string;
  readonly fontSize?: string;
}

export const Label = styled.span<ItemProps>`
  display: inline-block;
  margin: 10px 0 5px 0;
  font-size: 15px;
  font-family: 'Proxima Nova';

  ${props => {
    const color = `color: ${props.color};`;
    const cursor = `cursor: ${props.cursor};`;
    const fontSize = `font-size: ${props.fontSize};`;
    const fontWeight = `font-weight: ${props.fontWeight};`;
    const decoration = `text-decoration: ${props.decoration};`;

    return css`
       {
        ${color}
        ${cursor}
        ${fontSize}
        ${decoration}
        ${fontWeight}
      }
    `;
  }};
`;
